/*eslint-disable*/
import React from "react";
import logoWhite from "../../assets/logo-gie-white.svg";
import pg from '../../assets/img/pg.svg';
import effigaz from "../../assets/img/effigaz.svg";
import pyramide from "../../assets/img/pyramide.svg";
import GIEButton from "../GIEButton/GieButton";
import GIELink from "../GIELink/GIELink";

class GIEFooterTop extends React.Component {
  render() {
    return (
      <div className="row g-3">
        <div className="col-12 col-lg-3 d-flex flex-column gap-4">
          <img src={logoWhite} alt="Logo GIE" width="218" height="68"/>
          <span className="energy">L'énergie est notre avenir, économisons-la !</span>
          <a href="https://gie-sa.fr/contact/">
            <GIEButton classes={{root: 'orange-btn'}}>Contactez-nous</GIEButton>
          </a>
        </div>

        <div className="col-12 col-lg-3 d-flex flex-column gap-3">
          <h5 className="headline">NOUS TROUVER</h5>
          <address>
            14 Place des Halles<br/>
            67000 - Strasbourg<br/>
            Lundi - vendredi<br/>
            8h30 à 12h - 13h30 - 17h
          </address>
        </div>
        <div className="col-12 col-lg-3 d-flex flex-column gap-3">
          <h5 className="headline">ACCÈS RAPIDE</h5>
          <ul className="list-unstyled">
            <li>
              <GIELink className="color-white" href="https://gie-sa.fr/notre-entreprise/" arrowAfter>
                Notre entreprise
              </GIELink>
            </li>
            <li>
              <GIELink className="color-white" href="https://gie-sa.fr/chauffage/" arrowAfter>
                Chauffage
              </GIELink>
            </li>
            <li>
              <GIELink className="color-white" href="https://gie-sa.fr/climatisation/" arrowAfter>
                Climatisation
              </GIELink>
            </li>
            <li>
              <GIELink className="color-white" href="https://gie-sa.fr/energies-renouvelables/" arrowAfter>
                Énergies renouvelables
              </GIELink>
            </li>
          </ul>
        </div>
        <div className="col-12 col-lg-3 d-flex flex-column gap-4">
          <h5 className="headline">NOS QUALIFICATIONS</h5>
          <div className="d-flex gap-4 align-items-center">
            <img src={pyramide}/>
            <img src={pg}/>
            <img src={effigaz}/>
          </div>
          <a href="https://gie-sa.fr/#newsletter">
            <GIEButton classes={{root: 'white-btn'}}>Inscription à la newsletter</GIEButton>
          </a>
        </div>
      </div>
    );
  }
}

export default GIEFooterTop;
